import {cn} from '@/utils/common_functions';
import {Text, Icon} from '@/ui-kits';

interface TextInputClinicalNoteProps {
  label?: string;
  index?: number;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  multiline?: boolean;
  isEditing: boolean;
  onToggleEdit: () => void;
  isReadonly: boolean;
}
export const TextInputClinicalNote = (props: TextInputClinicalNoteProps) => {
  const {label, index, value, onChange, placeholder, multiline, isEditing, onToggleEdit, isReadonly} = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  const inputProps = {
    value,
    onChange: handleChange,
    placeholder: placeholder,
    className: cn(
      'px-3 py-2 lg:py-3 lg:px-4 debug border-none outline-none bg-transparent grow w-full font-FigtreeMedium placeholder:text-ui_grey scroll-hidden',
      multiline ? 'min-h-fit resize-none' : '',
    ),
    autoFocus: true,
    disabled: isReadonly || !isEditing,
  };

  return (
    <div className="flex flex-col gap-2">
      {/* label */}
      {label && (<div className="flex items-center gap-2 mb-2 sm:mb-3">
        <div className="size-5 sm:size-6 bg-gradient-to-br from-ui_blue to-ui_blue_light text-white rounded-full flex items-center justify-center">
          {index && <Text variant="small" className="!text-xs sm:!text-sm">{index}</Text>}
        </div>
        <Text variant="subtitle" className="text-ui_blue !text-base sm:!text-lg">
          {label}
        </Text>
      </div>)}

      {/* input */}
      <div className={cn('border flex border-ui_input_border bg-white relative !text-sm sm:!text-base rounded-lg overflow-hidden items-center disabled:cursor-not-allowed focus-within:border-2', isEditing && 'border-ui_blue')}>
        {multiline ? <textarea {...inputProps} /> : <input {...inputProps} />}
        {!isEditing && !isReadonly && (
          <button onClick={onToggleEdit} className="self-start mt-2 sm:mt-3 mr-2 cursor-pointer">
            <Icon type="edit_input" className="size-3.5 sm:size-4" />
          </button>
        )}
      </div>
    </div>
  );
};
